/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../storage/storage.ts" />
/// <reference path="../slideorfade/slideorfade.ts" />
/// <reference path="../htmlhelpers/htmlhelpers.ts" />

namespace Teva {
    export class Dropdown {
        static IsVisible: boolean = false;

        static Init() {
            $(document).on("click.dropdown", ".teva-dropdown-link", function () {
                return Dropdown.DropdownButtonClick($(this));
            });
        }
        static PageLoad() {
            $(document).trigger("click.dropdown-hide");
        }

        static DropdownButtonClick($Link, ForceShow?) {
            if ($Link.parents().filter(function () { return $(this).data("sortable-thresholdpassed") }).length > 0)
                return true;

            var $DropdownElement = $Link.closest(".teva-dropdown").first();
            var MenuElement = $DropdownElement[0].getAttribute("data-dropdown-menu");
            if (MenuElement == null) {
                MenuElement = $DropdownElement.data("dropdown-menu");
                if (MenuElement == null)
                    MenuElement = $DropdownElement.find(".teva-dropdown-menu");
            }
            var $MenuElement = MenuElement == null ? null : $(MenuElement);
            var RemoveOnHide = $MenuElement.hasClass("teva-dropdown-menu-single") == true;
            var MoveElement = $MenuElement.parent().prop("tagName") == "BODY";
            if (ForceShow == null)
                ForceShow = !$MenuElement.is(":visible");

            if (!ForceShow)
                Dropdown.HideInternal($MenuElement, RemoveOnHide, MoveElement);
            else {
                $(document).trigger("click.dropdown-hide");
                $(".tooltip").remove();
                Dropdown.ShowMenu($DropdownElement, $MenuElement, MoveElement, RemoveOnHide);
            }

            return true;
        }

        static LoadAjax($ContentContainer) {
            var $Ajax = $ContentContainer.find(".og-ajax");
            if ($Ajax.length == 0)
                return false;

            var Method = $Ajax.data("ajax-method");
            var URL = $Ajax.data("ajax-url");
            if (Method != "GET") {
                alert("Method not supported: " + Method);
                return false;
            }

            var Data = $Ajax.data("ajax-data");

            $Ajax.remove();
            $
                (document.createElement('div')
                    .addClass("filter-loading"))
                .append(document.createElement('span'))
                .appendTo($ContentContainer);

            $.ajax({
                url: URL,
                data: JSON.stringify(Data),
                contentType: "application/json",
                type: Method,
                success: function (HTML) {
                    $ContentContainer.css("min-height", $ContentContainer.css("height")).hide().html(HTML);
                    Teva.SlideOrFade.Show($ContentContainer, 400, function () {
                        $ContentContainer.css("min-height", "");
                    });
                    $(document).trigger("OfficeGuy.AjaxLoaded", $ContentContainer);
                }
            });
            return true;
        }

        static Show($DropdownElement) {
            var MenuElement = $DropdownElement.find(".teva-dropdown-menu");
            Dropdown.ShowMenu($DropdownElement, MenuElement, true, false);
        }

        static ShowMenu($DropdownElement, $MenuElement, MoveElement, RemoveOnHide) {
            $MenuElement.show();
            var $SingleAdditionalMenuButton = $MenuElement.children(":visible");
            if ($SingleAdditionalMenuButton.length != 1 || !$SingleAdditionalMenuButton.is(".teva-dropdown-menu-item-additional"))
                $SingleAdditionalMenuButton = null;
            $MenuElement.hide();
            if ($SingleAdditionalMenuButton != null) {
                $SingleAdditionalMenuButton.children("a").trigger("click");
                return;
            }
            $DropdownElement.append($MenuElement);
            Dropdown.LoadAjax($MenuElement);
            Dropdown.PositionMenu($DropdownElement, $MenuElement);

            //if (!$MenuElement.hasClass("teva-dropdown-menu-additional") || window.innerWidth <= 850) {
            $(document).one("click.dropdown-hide", function () {
                Dropdown.HideInternal($MenuElement, RemoveOnHide, MoveElement);
            });
            //}

            $MenuElement.fadeIn(200);
            $(document).on("keydown.dropdown", function (Event) {
                if (!$MenuElement.is(":visible")) {
                    $(document).off("keydown.dropdown");
                    return true;
                }

                if (Event.key == "ArrowDown") {
                    var $Focused = $(":focus");
                    if ($Focused.length > 0 && $Focused.parents(".teva-dropdown-menu").length > 0)
                        $Focused.nextAll("a:visible").first().trigger("focus");
                    else
                        $MenuElement.find("a:first").trigger("focus");
                    return false;
                }
                else if (Event.key == "ArrowUp") {
                    var $Focused = $(":focus");
                    if ($Focused.length > 0 && $Focused.parents(".teva-dropdown-menu").length > 0)
                        $Focused.prevAll("a:visible").first().trigger("focus");
                    else
                        $MenuElement.find("a:last").trigger("focus");
                    return false;
                }
                else if (Event.key == "Escape") {
                    Dropdown.HideInternal($MenuElement, RemoveOnHide, MoveElement);
                    $(document)
                        .off("keydown.dropdown")
                        .off("click.dropdown-hide");
                    return false;
                }
                return true;
            });
        }

        static HideInternal($MenuElement, RemoveOnHide, MoveElement) {
            $MenuElement.fadeOut(200, function () {
                if (RemoveOnHide)
                    $MenuElement.remove();
                else if (MoveElement)
                    $(document.body).append($MenuElement);
            });
        }

        static IsOpen($DropdownElement): boolean {
            return $DropdownElement.find(".teva-dropdown-menu").is(":visible");
        }

        static Hide() {
            $(document).trigger("click.dropdown-hide");
        }

        static PositionMenu($DropdownElement, $MenuElement) {
            if ($MenuElement.closest(".og-navigation-bar-buttons").length > 0 && window.innerWidth <= 850) {
                $MenuElement
                    .css("max-height", Math.max($(window).height() - $DropdownElement.height() - 100, 200) + "px")
                    .css("top", -$MenuElement.outerHeight(true) + "px");
            }
            else {
                $MenuElement
                    .css("max-height", Math.max(($(window).height() - ($DropdownElement.offset().top - $(window).scrollTop() - $(document.body).scrollTop()) - 10 - $DropdownElement.height()), 200) + "px")
                    .css("top", $DropdownElement.outerHeight(true) + "px");
            }
            var $Window = $DropdownElement.parents().filter(function () {
                var $this = $(this);
                return $this.css("overflow") == "scroll" || $this.css("overflow") == "auto";
            });
            if ($Window.length == 0)
                $Window = $(document.body);

            if (document.body.dir == "rtl") {
                if (($DropdownElement.hasClass("teva-dropdown-far") || (!$DropdownElement.hasClass("teva-dropdown-near") && ($DropdownElement.offset().left - $Window.offset().left) - $MenuElement.outerWidth() + $DropdownElement.outerWidth() < 0))
                    && $Window.width() - ($DropdownElement.offset().left - $Window.offset().left) - $MenuElement.outerWidth() >= 0)
                    $MenuElement.css("left", "0px").css("right", "");
                else
                    $MenuElement.css("right", "0px").css("left", "");
            }
            else {
                if ($DropdownElement.hasClass("teva-dropdown-far")
                    || (!$DropdownElement.hasClass("teva-dropdown-near") && ($DropdownElement.offset().left - $Window.offset().left) + $MenuElement.outerWidth() > $Window.width()))
                    $MenuElement.css("right", "0px").css("left", "");
                else
                    $MenuElement.css("left", "0px").css("right", "");
            }
        }
    }
}

$(document).on("Teva.Init", function () {
    Teva.Dropdown.Init();
});
$(document).on("Teva.PageLoad", function () {
    Teva.Dropdown.PageLoad();
});
